import { Component, Input, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { FeedbackComponent } from './feedback/feedback.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Input()patientId:String ='';
  public collapsed = true;
  closeResult = '';
  constructor(private modalService: NgbModal) { }

  open() {
    const modalRef = this.modalService.open(FeedbackComponent);
    modalRef.componentInstance.patientId = this.patientId;
  }

  ngOnInit(): void { 
  }
}
